import { render, staticRenderFns } from "./copy-24.vue?vue&type=template&id=7f106f80"
import script from "./copy-24.vue?vue&type=script&lang=js"
export * from "./copy-24.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports